export default __webpack_public_path__ + "static/media/uaca.775e91fc.png";